import { defineMessages } from "react-intl";

import { DisplayType } from "@app/scene/home/enum/DisplayType";

export const generalMessages = defineMessages({
  recordTypesDialogTitle: {
    id: "home.cards.recordsBySource.selectRecordTypesDialog.title",
    defaultMessage: "Select Record Types",
    description: "Title for select Record types dialog",
  },
  sourceTypesDialogTitle: {
    id: "home.cards.recordsBySource.selectSourceTypesDialog.title",
    defaultMessage: "Select Source Types",
    description: "Title for select source types dialog",
  },
});

export const displayTypeMessages = defineMessages<DisplayType>({
  [DisplayType.GROSS]: {
    id: "home.cards.recordsBySource.dropdown.menuItem.displayType.gross",
    defaultMessage: "Switch to %",
    description: "Source Card select gross displaytype option",
  },
  [DisplayType.PERCENT]: {
    id: "home.cards.recordsBySource.dropdown.menuItem.displayType.percent",
    defaultMessage: "Switch to gross number",
    description: "Source Card select percent displaytype option",
  },
});
